import React from 'react';
import { Head, Link } from '@inertiajs/react';
import DashboardLayout from '../components/DashboardLayout';
import { ThemeToggle } from '../components/ThemeToggle';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';

interface User {
  id: number;
  name?: string;
  username?: string;
  email: string;
  role: 'user' | 'manager' | 'admin';
}

interface SettingsProps {
  user: User;
}

export default function Settings({ user }: SettingsProps) {
  return (
    <DashboardLayout>
      <Head title="Settings" />
      <div className="container max-w-4xl py-8 px-4 md:px-8">
        <div className="space-y-6">
          {/* Page Header */}
          <div className="space-y-1">
            <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
          </div>

          {/* Appearance Settings */}
          <Card>
            <CardHeader>
              <CardTitle>Appearance</CardTitle>
              <CardDescription>
                Customize how the application looks and feels
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="space-y-0.5">
                  <Label htmlFor="theme-toggle">Theme</Label>
                  <p className="text-sm text-muted-foreground">
                    Toggle between light and dark mode
                  </p>
                </div>
                <ThemeToggle />
              </div>
            </CardContent>
          </Card>

          {/* Account Settings */}
          <Card>
            <CardHeader>
              <CardTitle>Account</CardTitle>
              <CardDescription>
                Manage your account
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <Button variant="destructive" asChild>
                <Link method="delete" href="/signout">Logout</Link>
              </Button>
            </CardContent>
          </Card>

        </div>
      </div>
    </DashboardLayout>
  );
}
